import { ENTITY_STATUS } from 'constants/status';

/**
 * Mock users. Login is by phone_number + password. `role_id` references a role
 * in roles.mock; the auth service resolves the role's permissions on login.
 */
export const MOCK_USERS = [
  {
    id: 'user-1',
    full_name: 'System Admin',
    phone_number: '9000000001',
    password: 'admin123',
    role_id: 'role-admin',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-01T00:00:00Z',
  },
  {
    id: 'user-2',
    full_name: 'Ravi Reviewer',
    phone_number: '9000000002',
    password: 'review123',
    role_id: 'role-reviewer',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-05T00:00:00Z',
  },
  {
    id: 'user-3',
    full_name: 'Sana Storage',
    phone_number: '9000000003',
    password: 'store123',
    role_id: 'role-storage',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-06T00:00:00Z',
  },
  {
    id: 'user-4',
    full_name: 'Deepak Data',
    phone_number: '9000000004',
    password: 'data123',
    role_id: 'role-dataentry',
    status: ENTITY_STATUS.ACTIVE,
    created_at: '2026-01-07T00:00:00Z',
  },
];

export default MOCK_USERS;
